// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1714f0f1","455":"3129ff91"}[chunkId] + ".chunk.js";
};